import { gql } from 'graphql-request';


export const SAVED_MARKET_STATE_FILTER_FILTER_FRAGMENT = gql`
	fragment SavedMarketStateFilterFilterFragment on SavedMarketStateFilterFilter {
      roomTypes
      provider
      platform
      region
      ratesType
      nights
      guests
      airportCode
      meal
      refunding
  }`

export const SAVED_MARKET_STATE_FILTER_FRAGMENT = gql`
    ${SAVED_MARKET_STATE_FILTER_FILTER_FRAGMENT}
    fragment SavedMarketStateFilterFragment on SavedMarketStateFilter {
        id
        name
        isDefault
        companyHotelId
        filter {
            ...SavedMarketStateFilterFilterFragment
        }
    }
`